if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
        this.pincodeData = [];
        this.monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        this.weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
        this.moveOffers();
        this.moveBadges();
        this.clickEvent();
        this.getData();
        this.setSizeChart();
        if (setCookie) setCookie('pUrl',window.location.href);
      }
      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      setSizeChart = () =>{
        const table = document.querySelector('.data-table-wrapper .units-table');
        const allTD = table?.querySelectorAll('td');
        allTD?.forEach((td)=>{
          const content = td.textContent.trim();
          if (!isNaN(content)) {
            // Set content as a data attribute
            td.dataset.inches = content;
            td.dataset.cm = Math.ceil(parseInt(content) * 2.45);
          }
        })
      }

      moveBadges() {
        let contentDiv = document.querySelector('#shopify-section-pdp-badge-section');
        if (!contentDiv) {
          return;
        }
        let content = contentDiv.innerHTML;
        let target = this.querySelector('.badge-paste');
        if (!target) {
          return;
        }
        target.innerHTML = content;
        contentDiv.innerHTML = '';
      }
      moveOffers() {
        let contentDiv = document.querySelector('#shopify-section-pdp-offer-section');
        if (!contentDiv) {
          return;
        }
        let content = contentDiv.innerHTML;
        let target = this.querySelector('.offer-section-wrapper');
        if (!target) {
          return;
        }
        // target.querySelector('.offer-paste').innerHTML = content;
        contentDiv.innerHTML = "";
      }
      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay')?.classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay')?.classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      getData = async () => {
        let form = qs('.delivery-option-wrapper',this);
        let url = form?.getAttribute('data-express');
        try{
          let data = await fetch(url);
          data = await data.json();
          this.pincodeData = data;
        }catch(e){
          console.log(e);
        }
      }

      findETA = (estimateBtn,checkPincodeText,updateDate,etaResult,etaResultText) => {
        let input = qs('.delivery-option-wrapper .pincode-eta-input',this);
        let deliveryInformation = qs('.delivery-option-wrapper .delivery-information',this);
        let value = input.value;
        let eta = this.pincodeData.find((item)=> parseInt(item.Pincode) == parseInt(value));
        if(eta){
          let currentDate = new Date(window.currentDate);
          currentDate.setDate(currentDate.getDate() + parseInt(eta.T));
          updateDate.innerHTML = `Get it by ${this.weekday[currentDate.getDay()]}, ${this.monthNames[currentDate.getMonth()]} ${currentDate.getDate()}`
          checkPincodeText.innerText = 'check';
          estimateBtn.classList.add('change-active');
          deliveryInformation.classList.add('active');
        }else{
          etaResult.innerText = "We are currently not delivering to this pin code."
          etaResult.classList.add('text-danger');
          checkPincodeText.innerText = 'check';
          estimateBtn.classList.remove('change-active');
          deliveryInformation.classList.remove('active');
          setTimeout(() => {
            input.value = '';
            input.focus();
            etaResult.innerText = etaResultText;
            etaResult.classList.remove('text-danger');
          }, 3000);
        }
      }

      clickEvent = () => {
        // Accordion 
        const accSingleTriggers = qsa('.js-acc-single-trigger',this);
        accSingleTriggers.length > 0 && accSingleTriggers.forEach(trigger => {
          trigger.addEventListener('click', ()=> {
            const items = qsa('.js-acc-item',this);
            const thisItem = trigger.parentNode;
          
            items.forEach(item => {
              if (thisItem == item) {
                thisItem.classList.toggle('is-open');
                return;
              }
              item.classList.remove('is-open');
            });
          })
        });
    
        // View all offers 
        let view_text = qs('.view-all-text',this);
        let View_all_popup = qs('.view-more-popup-wrapper');
        let close_btn = qs('.popup-header .close-icon');
        view_text?.addEventListener('click', () => {
          View_all_popup.classList.add('popup-open');
          document.body.classList.add(`overflow-hidden`);
        })
        close_btn?.addEventListener('click', () => {
          View_all_popup.classList.remove('popup-open');
          document.body.classList.remove(`overflow-hidden`);
        })
        View_all_popup?.addEventListener('click', (e) => {
          if(e.target !== e.currentTarget) return;
          View_all_popup.classList.remove('popup-open');
          document.body.classList.remove(`overflow-hidden`);
        })

        // Complete look
        let look_button_text = qs('.complete-look-title',this);
        let look_popup = qs('.complete-the-look-popup');
        let close_icon = qs('.complete-the-look-bg-wrapper .close-icon');
        look_button_text?.addEventListener('click', (e) => {
          e.preventDefault();
          look_popup.classList.add('popup-open');
          document.body.classList.add(`overflow-hidden`);
        })
        close_icon?.addEventListener('click', () => {
          look_popup.classList.remove('popup-open');
          document.body.classList.remove(`overflow-hidden`);
        })
        look_popup?.addEventListener('click', (e) => {
          if(e.target !== e.currentTarget) return;
          look_popup.classList.remove('popup-open');
          document.body.classList.remove(`overflow-hidden`);
        })

        // Size chart 
        let InchTable = qs('.inches-table',this);
        let CmTable = qs('.cm-table',this);
        let InchradioBtn = qs('#inches',this);
        let CmadioBtn = qs('#cm',this);

        CmadioBtn?.addEventListener('click', () => {
          if (CmadioBtn.checked) {
            CmTable?.classList.add('active');
            InchTable?.classList.remove('active');
          }
        });

        InchradioBtn?.addEventListener('click', () => {
          if (InchradioBtn.checked) {
            InchTable?.classList.add('active');
            CmTable?.classList.remove('active');
          }
        });

        // buy now 
        let shopifyPaymentButton = qs('.shopify-payment-button__button',this);
        shopifyPaymentButton && shopifyPaymentButton.addEventListener('click',()=>{
          this.addCartCheckout(shopifyPaymentButton.dataset.formId);
        })

        // size chart CM / INCHES
        let sizeUnits = qsa('.size-chart-modal-wrapper .custom-radio');
        sizeUnits.length > 0 && sizeUnits.forEach(el=>{
          el.addEventListener('change',()=> {
            let unit = document.querySelector('.custom-radio:checked');
            const table = document.querySelector('.data-table-wrapper .units-table');
            const allTD = table.querySelectorAll('td');
            if(unit && table){
              
                allTD.forEach((td)=>{
                  const content = td.textContent.trim();
                  if (!isNaN(content)) {
                    // Set content as a data attribute
                    if(unit.id == 'inches'){
                      td.textContent = td.dataset.inches;
                    }else{
                      td.textContent = td.dataset.cm;
                    }
                  }
                })
              
            }
            // qsa('.data-table-wrapper .units-table').forEach(table=> table.classList.remove('active'))
            // qs(el.dataset.class).classList.add('active');
          })
        })

        // estimated delivery
        let estimateBtn = qs('.estimated-delivery-button',this);
        let etaResult = qs('.delivery-option-wrapper .information-text',this);
        let etaResultText = etaResult.innerText;
        let input = qs('.delivery-option-wrapper .pincode-eta-input',this);
        let updateDate = qs('.delivery-option-wrapper .update-date',this);
        let updateDateText = updateDate.innerText;
        let deliveryInformation = qs('.delivery-option-wrapper .delivery-information',this);
        input?.addEventListener('input',async ()=> {
          let value = input.value;
          if (value.length > 6) input.value = value.slice(0, 6);
          if(!value){
            estimateBtn.classList.remove('change-active');
            deliveryInformation.classList.remove('active');
            updateDate.innerText = updateDateText;
          }
        })
        estimateBtn?.addEventListener('click',async ()=> {
          if (estimateBtn.classList.contains('change-active')) {
            input.value = '';
            input.focus();
            estimateBtn.classList.remove('change-active');
            deliveryInformation.classList.remove('active');
            updateDate.innerText = updateDateText;
            return;
          }
          let checkPincodeText = qs('.check-pincode-text',estimateBtn);
          let value = input.value;
          if(!value) {
            etaResult.innerText = 'Please Enter a Valid Pincode';
            etaResult.classList.add('text-danger');
            setTimeout(() => {
              etaResult.innerText = etaResultText;
              etaResult.classList.remove('text-danger');
            }, 2000);
            return;
          }
          checkPincodeText.innerText = 'Checking...';
          if(this.pincodeData.length <= 0){
            await this.getData();
            this.findETA(estimateBtn,checkPincodeText,updateDate,etaResult,etaResultText);
          }else{
            this.findETA(estimateBtn,checkPincodeText,updateDate,etaResult,etaResultText);
          }
        })
      }

      addCartCheckout = (formId) => {
        let form = qs(`form#${formId}[action="/cart/add"]`);
        let formData = new FormData(form);
        fetch('/cart/add', {
            method: 'POST',
            body: formData
        }).then(function (response) {
          if (response.ok) {
            location.href='/checkout';
            return response.json();
          }
          throw response;
        }).then(function (data) {
            // console.log(data);
        }).catch(function (error) {
            console.warn(error);
        });
      }
    }
  );
}
